import { defineMessage } from 'services/localization';

export const messages = {
    titleEdit: defineMessage('edit_payment_details'),
    titleNew: defineMessage('new_payment_details'),
    save: defineMessage('save'),
    helpText: defineMessage('what_are_contact_payment_details'),
    learnMore: defineMessage('learn_more'),
    inputPlaceholder: defineMessage('enter'),
    selectPlaceholder: defineMessage('select'),
    defaultCheckbox: defineMessage('set_as_default'),
    bankAccountCountry: defineMessage('bank_account_country'),
    bankAccountCurrency: defineMessage('bank_account_currency'),
    accountName: defineMessage('account_name'),
    accountNamePlaceholder: defineMessage('business_or_person_name_of_payee'),
    bankAccountNumber: defineMessage('bank_account_number'),
    sortCode: defineMessage('sort_code'),
    remove: defineMessage('remove_payment_details'),
    requiredField: defineMessage('field_is_required'),
    sortCodeValidationError: defineMessage('sort_code_should_be_digits'),
    bankAccountNumberValidationError: defineMessage('bank_account_number_should_be_digits'),
    bankAccountNameValidationError: defineMessage('bank_account_name_should_be_characters_long'),
    bankAccountNameRestrictedCharsError: defineMessage('bank_account_name_shoul_llowing_restrictedchars_1'),
};
